<template>
  <div>

    <b-col cols="12">
      <b-card :title="$t('assinatura.titlePrimeiroCard')">
        <b-card-text>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="mt-1"
            >
              <div class="mb-6">
                <h4 class="text-base font-weight-medium mb-1">
                  {{ $t('assinatura.subTitlePrimeiroCard') }}
                  <b-badge
                    variant="light-primary"
                  >
                    {{ assinaturas[0].variacao.nome }}
                  </b-badge>
                  <b-button
                    v-if="assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO' || assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO_TAXA_DESEMPENHO_PREPAGO'"
                    v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                    v-b-modal.modal-plans
                    variant="primary"
                    size="sm"
                    class="ml-2"
                  >
                    {{ $t('assinatura.upgradeBtn') }}
                  </b-button>
                </h4>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="mt-1"
            >
              <div class="mb-6">
                <h4 class="text-base font-weight-medium mb-1">
                  <b-badge
                    :variant="assinaturas[0].status === 'Ativo' ? 'light-success' : 'light-danger'"
                  >
                    {{ assinaturas[0].status }}
                  </b-badge>
                  <template v-if="assinaturas[0].dataFim">
                    {{ $t('assinatura.textComplementoAte') }} {{ formattedDate(assinaturas[0].dataFim) }}
                  </template>
                </h4>
              </div>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-col>

    <b-col
      v-if="assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO' || assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO_TAXA_DESEMPENHO_PREPAGO' && diasRestantes < 5"
      cols="12"
    >
      <b-card :title="$t('assinatura.titleSegundoCard')">
        <b-row>
          <b-alert
            color="warning"
            variant="warning"
            show
          >
            <div class="alert-body">
              <template v-if="diasRestantes >= 0">
                {{ $t('assinatura.alertTextAntesVencer') }}
                <strong v-if="diasRestantes > 0">{{ diasRestantes == 1 ? 'Resta '+diasRestantes+ ' dia': 'Restam '+diasRestantes+ ' dias' }}</strong>
              </template>
              <template v-else>
                <strong>{{ $t('assinatura.primeiroAlertTextVecimento') }}</strong> {{ $t('assinatura.segundoAlertTextVecimento') }}
              </template>
            </div>
          </b-alert>
        </b-row>

        <div
          v-if="assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO' || assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO_TAXA_DESEMPENHO_PREPAGO' && diasRestantes < 5"
          class="mt-1"
        >
          <h4 class="text-base font-weight-medium mb-2">
            {{ $t('assinatura.subTitleRecarga') }}
          </h4>

          <div class="sf-pricing-grid">
            <div
              v-for="planoVar in planoVariacaoRecorrencia"
              :key="planoVar.id"
              class="sf-pricing-card"
            >
              <b-img
                :src="require('@/assets/images/illustration/badge.svg')"
                class="sf-pricing-icon"
                alt="basic svg img"
              />
              <div class="sf-pricing-name">
                Plan
                <b-badge variant="warning">
                  {{ planoVar.nome }}
                </b-badge>
              </div>
              <div class="sf-pricing-price-row">
                <span class="sf-pricing-currency">$</span>
                <span class="sf-pricing-value">{{ planoVar.precoFinal }}</span>
              </div>
              <b-link
                v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                class="sf-pricing-btn mt-2"
                :to="{ name: 'checkout-recorrencia', params: { nomePlano: assinaturas[0].plano.nomeUrl, nomePlanoVariacao: planoVar.nomeUrl } }"
              >
                {{ $t('assinatura.recarregarBtn') }}
              </b-link>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>

    <b-col
      v-if="assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO' || assinaturas[0].tipoCobranca=='CHECKOUT_INTERNO_TAXA_DESEMPENHO_PREPAGO'"
      cols="12"
    >
      <b-card :title="$t('assinatura.titleTerceiroCard')">
        <b-table-lite
          sticky-header="300px"
          hover
          responsive
          :items="assinaturas"
          :fields="['id','status', 'plano', 'valor', 'periodo', 'dataVencimento', 'dataPagamento']"
        >

          <template #cell(status)="data">
            <div class="text-nowrap">
              <b-badge variant="light-success">
                {{ data.item.pagamentos[0].status }}
              </b-badge>
            </div>
          </template>

          <template #cell(plano)="data">
            <div class="text-nowrap">
              {{ data.item.variacao.nome }}
            </div>
          </template>

          <template #cell(valor)="data">
            <div class="text-nowrap">
              ${{ data.item.pagamentos[0].valor }}
            </div>
          </template>

          <template #cell(periodo)="data">
            <div class="text-nowrap">
              {{ formattedDateMoment(data.item.dataInicio) }} - {{ formattedDateMoment(data.item.dataFim) }}
            </div>
          </template>

          <template #cell(dataVencimento)="data">
            {{ formattedDateMoment(data.item.pagamentos[0].dataVencimento) }}
          </template>

          <template #cell(dataPagamento)="data">
            {{ formattedDateTimeMoment(data.item.pagamentos[0].dataPagamento) }}
          </template>

        </b-table-lite>
      </b-card>
    </b-col>

    <b-modal
      v-if="planos && planos.length > 0"
      id="modal-plans"
      hide-footer
      scrollable
      size="xl"
    >

      <section id="pricing-plan">
        <div class="sf-pricing-head">
          <h1 class="sf-pricing-title">
            {{ $t('assinatura.titlePrecoPlanos') }}
          </h1>
          <p class="sf-pricing-subtitle">
            {{ $t('assinatura.textPrecoPlanos') }}
          </p>
        </div>

        <div
          v-for="plano in planos"
          :key="plano.id"
          class="sf-pricing-grid mb-3"
        >
          <div
            v-for="planoVar in planVariacaoUpgrade(plano)"
            :key="planoVar.id"
            class="sf-pricing-card"
            :class="{ popular: planoVar && planoVar.popular }"
          >
            <span
              v-if="planoVar && planoVar.popular"
              class="sf-pricing-popular-badge"
            >{{ $t('assinatura.textBadgePrecoPopular') }}</span>

            <b-img
              :src="require('@/assets/images/illustration/badge.svg')"
              class="sf-pricing-icon"
              alt="basic svg img"
            />
            <div class="sf-pricing-name">
              {{ plano.nome }}
              <b-badge variant="warning">
                {{ planoVar.nome }}
              </b-badge>
            </div>

            <div class="sf-pricing-price-row">
              <span class="sf-pricing-currency">$</span>
              <span class="sf-pricing-value">{{ planoVar.precoFinal }}</span>
            </div>
            <div class="sf-pricing-duration">
              (
              {{ planoVar.preco }} {{ $t('ativacao.licencia') }}
              <template v-if="planoVar.creditoTaxaDesempenho > 0">
                + {{ planoVar.creditoTaxaDesempenho }} {{ $t('ativacao.creditoTaxaDesempenho') }}
              </template>
              )
            </div>

            <ul class="sf-pricing-benefits">
              <li
                v-for="(item, index) in planoVar.beneficio"
                :key="index"
              >
                <feather-icon icon="CheckIcon" />
                <span>{{ item }}</span>
              </li>
            </ul>

            <b-link
              v-ripple.400="'rgba(59, 130, 246, 0.15)'"
              class="sf-pricing-btn"
              :class="{ 'sf-pricing-btn-outline': temAssinatura(planoVar.id), disabled: temAssinatura(planoVar.id) }"
              :to="{ name: 'checkout-upgrade', params: { nomePlano: plano.nomeUrl, nomePlanoVariacao: planoVar.nomeUrl } }"
            >
              {{ temAssinatura(planoVar.id)? 'Tu plan actual': parseFloat(planoVar.preco) > parseFloat(assinaturas[0].variacao.preco)? 'Upgrade': 'Downgrade' }}
            </b-link>
          </div>
        </div>
      </section>
    </b-modal>

  </div>

</template>

<script>
import {
  BCard, BBadge, VBToggle, BRow, BCol, BImg, BLink, BCardText, BButton, BModal, VBModal, BTableLite, BAlert,
} from 'bootstrap-vue'

import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { formatDateBR, formatDateTimeBR, formatDateSemDiaBR } from '@/utils/filter'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import moment from 'moment'
import assinaturaStoreModule from './assinaturaStoreModule'

const CONTA_ASSINATURA_STORE_MODULE_NAME = 'conta-assinatura'

export default {

  components: {
    BCard,
    BBadge,
    BRow,
    BCol,
    BImg,
    BLink,
    BCardText,
    BButton,
    BModal,
    BTableLite,
    BAlert,
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
    'b-toggle': VBToggle,
  },

  data() {
    return {
      assinaturas: [],
      planos: [],
      planoVariacaoRecorrencia: [],
      pagamento: {
        forma: null,
        id: null,
      },
      formatDateBR,
      formatDateTimeBR,
      formatDateSemDiaBR,
    }
  },

  computed: {

    totalDias() {
      return this.calculateDaysDifference(this.assinaturas[0].dataInicio, this.assinaturas[0].dataFim)
    },

    diasRestantes() {
      if (this.assinaturas[0] && this.assinaturas[0].dataFim) {
        return this.calculateDaysDifference(new Date(), this.assinaturas[0].dataFim)
      }
      return 0
    },
  },

  created() {
    if (!store.hasModule(CONTA_ASSINATURA_STORE_MODULE_NAME)) store.registerModule(CONTA_ASSINATURA_STORE_MODULE_NAME, assinaturaStoreModule)
    this.getPlanos()
    this.getAssinatura()
  },

  beforeDestroy() {
    if (store.hasModule(CONTA_ASSINATURA_STORE_MODULE_NAME)) store.unregisterModule(CONTA_ASSINATURA_STORE_MODULE_NAME)
  },

  methods: {

    planVariacaoUpgrade(plano) {
      return plano.planoVariacao.filter(planoVar => !planoVar.recorrenciaDesabilitada)
    },

    temAssinatura(id) {
      // Verifica se existe alguma assinatura com variacao.id igual a id
      return this.assinaturas.some(assinatura => assinatura.variacao.id === id && assinatura.status === 'Ativo')
    },

    formattedDate(originalDate) {
      // eslint-disable-next-line global-require
      const dateObject = new Date(originalDate)
      return format(dateObject, 'dd MMMM \'de\' yyyy', { locale: ptBR })
    },

    formattedDateMoment(originalDate) {
      return moment(originalDate).format('DD/MM/YYYY')
    },

    formattedDateTimeMoment(originalDate) {
      return moment(originalDate).format('DD/MM/YYYY HH:mm:ss')
    },

    calculateDaysRemaining(endDate) {
      const today = new Date()
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const daysRemaining = Math.round(Math.abs((today - new Date(endDate)) / oneDay))

      return daysRemaining
    },

    calculateDaysDifference(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr)
      const endDate = new Date(endDateStr)
      // Calcula a diferença em milissegundos
      const timeDifference = endDate - startDate
      // Converte a diferença de milissegundos para dias
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24))

      return daysDifference
    },

    getAssinatura() {
      store
        .dispatch('conta-assinatura/getAssinatura')
        .then(response => {
          this.assinaturas = response.data
          if (response.data[0].tipoCobranca === 'CHECKOUT_INTERNO' || response.data[0].tipoCobranca === 'CHECKOUT_INTERNO_TAXA_DESEMPENHO_PREPAGO') {
            this.getPlanoRecorrencia(response.data[0].plano.nomeUrl)
          }
        })
    },
    getPlanos() {
      store
        .dispatch('conta-assinatura/getPlanos')
        .then(response => {
          this.planos = response.data
        })
    },
    getPlanoRecorrencia(nomePlano) {
      store
        .dispatch('conta-assinatura/getPlanoRecorrencia', { nomePlano })
        .then(response => {
          this.planoVariacaoRecorrencia = response.data
        })
    },
  },

}
</script>

<style lang="scss" scoped>
/* ============================================================
   Pricing cards — padrão Soulf (planos/upgrade/recarga).
   ============================================================ */
.sf-pricing-head { text-align: center; margin: 24px 0 28px; }
.sf-pricing-title { font-size: 22px; font-weight: 600; color: #fff; margin: 0 0 6px; }
.sf-pricing-subtitle { font-size: 13.5px; color: rgba(255, 255, 255, 0.55); margin: 0; }

.sf-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 20px;
}

.sf-pricing-card {
  position: relative;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 16px;
  padding: 28px 22px;
  text-align: center;
  display: flex;
  flex-direction: column;

  &.popular { border-color: rgba(59, 130, 246, 0.40); }
}
.sf-pricing-popular-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  font-family: 'Geist', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.12);
  border-radius: 9999px;
  padding: 3px 10px;
}
.sf-pricing-icon { width: 52px; height: 52px; margin: 0 auto 14px; opacity: 0.9; }
.sf-pricing-name {
  font-family: 'Geist', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.sf-pricing-price-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin: 18px 0 4px;
}
.sf-pricing-currency {
  font-family: 'Geist Mono', 'SFMono-Regular', Menlo, monospace;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
}
.sf-pricing-value {
  font-family: 'Geist Mono', 'SFMono-Regular', Menlo, monospace;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
}
.sf-pricing-duration {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 18px;
}
.sf-pricing-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 9px;
  flex: 1;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.70);
    line-height: 1.4;

    .feather {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      margin-top: 2px;
      color: #4ade80;
    }
  }
}
.sf-pricing-btn {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  background: #3b82f6;
  color: #fff !important;
  font-family: 'Geist', sans-serif;
  font-weight: 600;
  font-size: 13px;
  padding: 11px 0;
  border-radius: 9999px;
  cursor: pointer;
  text-decoration: none;
  transition: transform .15s ease, opacity .15s ease;

  &:hover { transform: translateY(-2px); color: #fff !important; text-decoration: none; }
  &.sf-pricing-btn-outline {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: rgba(255, 255, 255, 0.70) !important;
  }
  &.disabled, &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
    pointer-events: none;
  }
}
</style>
